import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

const SiteMaintenance = () => {
    const [isOpenMaintain, setIsOpenMaintain] = useState(true);
    const handleClose = () => { setIsOpenMaintain(false) }
    return (
        <>
            <Modal show={isOpenMaintain} onHide={handleClose} backdrop="static"
                keyboard={false} size="lg" aria-labelledby="contained-modal-title-vcenter" centered >
                <Modal.Header>
                    <h5 className='container text-center'>Site Under Maintenance</h5>
                    <h5 className="pop-close" style={{ cursor: 'pointer', color: 'black' }} onClick={() => setIsOpenMaintain(false)}>X</h5>
                </Modal.Header>
                <Modal.Body className="pb-2 pt-2">
                    <div className="container p-4" style={{ fontFamily: 'Arial, sans-serif', fontSize: '16px', color: '#333' }}>
                        <p><strong>Dear Users,</strong></p>
                        <p>
                            We are upgrading our servers hence the website and application response will be delayed
                            Also, Site will remain close from Friday 30Th May 2025 from 10:00pm(IST) to 11:00pm (IST) of Saturday 31st May 2025.
                        </p>
                        <p>Thank you for your patience and understanding.</p>
                        <p className="mt-4">
                            <strong>Warm regards,<br />India ITME Society Web Team</strong>
                        </p>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default SiteMaintenance;
